/** Coerces a value to a finite number, or null if the value is absent or non-finite. */
export function toNumberOrNull(value) {
  if (value === null || value === undefined) return null;
  const num = typeof value === "number" ? value : Number(value);
  return Number.isFinite(num) ? num : null;
}

/** Formats a finite-number change as "+X.X%" or null for absent/invalid values. */
export function formatChangePct(value) {
  const num = toNumberOrNull(value);
  if (num === null) return null;
  const sign = num >= 0 ? "+" : "";
  return `${sign}${num.toFixed(1)}%`;
}

/** Returns the CSS color variable appropriate for a change value. */
export function getChangeColor(value) {
  const num = toNumberOrNull(value);
  if (num === null) return "var(--text-muted)";
  return num >= 0 ? "var(--indicator-green)" : "var(--error)";
}
